import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { LocalScanningWebApiService } from '../../../services/local-scanning-web-api.service';
import { map, startWith, take, tap } from 'rxjs/operators';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PendingCollectionService } from '../../../services/pending-collection.service';
import { Pending } from '../pending.model';
import { BiographicTableComponent } from '../table/table.component';
import { searchObjectKeys } from '../../shared/data-source-filter-predicate';
import { EcaMonotronModule, EcaNoResultsModule, EcaSearchModule } from '@drc-eca/eca-components-lib';
import { NavComponent } from '../../shared/nav/nav.component';
import { MatFormField } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';
import { AsyncPipe } from '@angular/common';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'eca-pending-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  imports: [EcaMonotronModule, NavComponent, FormsModule, ReactiveFormsModule, MatFormField, EcaSearchModule, MatButton, ThrottleClickDirective, BiographicTableComponent, EcaNoResultsModule, AsyncPipe]
})
export class BiographicsViewComponent implements OnInit {
  private router = inject(Router);
  private api = inject(LocalScanningWebApiService);
  private pendingCollection = inject(PendingCollectionService);


  @ViewChild('bioTable') table: BiographicTableComponent;

  biographics: Pending[];
  pending$: Observable<Pending[]>;
  filteredPending$: Observable<Pending[]>;

  form: UntypedFormGroup;
  selected: Pending[] = [];

  readonly filterKeys: Array<keyof Pending> = [
    'lithocode',
    'form',
    'stateStudentId',
    'gender',
    'firstName',
    'lastName',
    'birthDate',
  ];

  ngOnInit() {
    this.form = new UntypedFormGroup({
      search: new UntypedFormControl(''),
    });

    this.pending$ = this.pendingCollection.pending$.pipe(
      tap(bios => this.biographics = bios)
    );

    this.filteredPending$ = combineLatest([
      this.pending$,
      this.form.get('search').valueChanges.pipe(startWith('')),
    ]).pipe(
      map(([pending, search]) => {
        return pending.filter(pendingValue => searchObjectKeys(pendingValue, this.filterKeys, search));
      }),
    );
  }

  onSelection(selected: Pending[]) {
    this.selected = selected;
  }

  submitToScoring() {
    if (!this.selected.length) {
      return;
    }

    this.api.submitDocumentsToScoring(this.selected)
      .pipe(
        take(1),
        tap(() => {
          if (this.table) {
            // let remaining = difference(this.biographics, this.selected);
            this.table.clearSelection(this.selected);
            this.pendingCollection.remove(this.selected);
            this.selected = [];
          }
        }),
      )
      .subscribe();

    this.pendingCollection.pollForNewAlerts();

    /*
      this.store.dispatch(new SubmitToScoring(this.sessionId));
      this.router.navigate(['/scoring-results']);
    */
  }

}
